import React, { createContext, useContext, useState, useEffect } from 'react';

// Available languages
export const LANGUAGES = {
  ru: { code: 'ru', name: 'Русский', flag: '🇷🇺' },
  en: { code: 'en', name: 'English', flag: '🇺🇸' },
  kz: { code: 'kz', name: 'Қазақша', flag: '🇰🇿' },
};

// Translations
const translations = {
  ru: {
    // Navigation
    'nav.dashboard': 'Дашборд',
    'nav.payments': 'Платежи',
    'nav.merchants': 'Мерчанты',
    'nav.providers': 'Провайдеры',
    'nav.terminals': 'Терминалы',
    'nav.commissions': 'Комиссии',
    'nav.reports': 'Отчёты',
    'nav.analytics': 'Аналитика',
    'nav.aml': 'AML',
    'nav.audit': 'Аудит',
    'nav.users': 'Пользователи',
    'nav.notifications': 'Уведомления',
    'nav.webhooks': 'Webhooks',
    'nav.settings': 'Настройки',
    'nav.logout': 'Выйти',

    // Common
    'common.search': 'Поиск',
    'common.filter': 'Фильтр',
    'common.add': 'Добавить',
    'common.edit': 'Редактировать',
    'common.delete': 'Удалить',
    'common.save': 'Сохранить',
    'common.cancel': 'Отмена',
    'common.confirm': 'Подтвердить',
    'common.loading': 'Загрузка...',
    'common.noData': 'Нет данных',
    'common.refresh': 'Обновить',
    'common.export': 'Экспорт',
    'common.all': 'Все',
    'common.active': 'Активен',
    'common.inactive': 'Неактивен',
    'common.status': 'Статус',
    'common.actions': 'Действия',
    'common.name': 'Название',
    'common.email': 'Email',
    'common.password': 'Пароль',
    'common.role': 'Роль',
    'common.created': 'Создан',
    'common.updated': 'Обновлён',
    'common.total': 'Всего',
    'common.success': 'Успешно',
    'common.error': 'Ошибка',
    'common.yes': 'Да',
    'common.no': 'Нет',
    'common.copy': 'Копировать',
    'common.copied': 'Скопировано',
    'common.date': 'Дата',
    'common.type': 'Тип',
    'common.description': 'Описание',
    'common.details': 'Детали',
    'common.close': 'Закрыть',
    'common.create': 'Создать',
    'common.update': 'Обновить',
    'common.view': 'Просмотр',

    // Auth
    'auth.login': 'Войти',
    'auth.logout': 'Выйти',
    'auth.email': 'Email',
    'auth.password': 'Пароль',
    'auth.loginTitle': 'Вход в систему',
    'auth.loginSubtitle': 'Введите данные для входа',
    'auth.loginError': 'Неверный email или пароль',
    'auth.welcome': 'Добро пожаловать',

    // Dashboard
    'dashboard.title': 'Дашборд',
    'dashboard.totalPayments': 'Всего платежей',
    'dashboard.totalAmount': 'Общий оборот',
    'dashboard.conversion': 'Конверсия',
    'dashboard.avgCheck': 'Средний чек',
    'dashboard.successful': 'Успешных',
    'dashboard.failed': 'Отклонённых',
    'dashboard.pending': 'В обработке',
    'dashboard.todayPayments': 'Платежей сегодня',
    'dashboard.todayAmount': 'Сумма сегодня',
    'dashboard.merchants': 'Мерчантов',
    'dashboard.terminals': 'Терминалов',

    // Users
    'users.title': 'Пользователи',
    'users.subtitle': 'Управление сотрудниками системы',
    'users.addUser': 'Добавить пользователя',
    'users.editUser': 'Редактировать пользователя',
    'users.deleteUser': 'Удалить пользователя',
    'users.searchPlaceholder': 'Поиск по имени или email...',
    'users.allRoles': 'Все роли',
    'users.allStatuses': 'Все статусы',
    'users.blocked': 'Заблокирован',
    'users.admins': 'Администраторов',
    'users.telegram': 'Telegram ID',
    'users.confirmDelete': 'Вы действительно хотите удалить этого пользователя?',
    'users.block': 'Заблокировать',
    'users.unblock': 'Разблокировать',
    'users.totalUsers': 'Всего пользователей',
    'users.activeUsers': 'Активных',
    'users.blockedUsers': 'Заблокированных',
    'users.role': 'Роль',
    'users.name': 'Имя',
    'users.lastLogin': 'Последний вход',
    'users.status': 'Статус',

    // Payments
    'payments.title': 'Платежи',
    'payments.subtitle': 'История транзакций',
    'payments.search': 'Поиск платежей',
    'payments.refund': 'Возврат',
    'payments.amount': 'Сумма',
    'payments.merchant': 'Мерчант',
    'payments.gateway': 'Шлюз',
    'payments.approved': 'Одобрен',
    'payments.declined': 'Отклонён',
    'payments.processing': 'В обработке',
    'payments.refunded': 'Возвращён',
    'payments.id': 'ID платежа',
    'payments.card': 'Карта',
    'payments.confirmRefund': 'Подтвердить возврат?',

    // Merchants
    'merchants.title': 'Мерчанты',
    'merchants.subtitle': 'Управление мерчантами',
    'merchants.search': 'Поиск мерчантов...',
    'merchants.addMerchant': 'Добавить мерчанта',
    'merchants.editMerchant': 'Редактировать мерчанта',
    'merchants.deleteMerchant': 'Удалить мерчанта',
    'merchants.confirmDelete': 'Вы уверены, что хотите удалить мерчанта?',
    'merchants.company': 'Компания',
    'merchants.bin': 'БИН',
    'merchants.phone': 'Телефон',
    'merchants.address': 'Адрес',
    'merchants.balance': 'Баланс',

    // Terminals
    'terminals.title': 'Терминалы',
    'terminals.subtitle': 'Управление терминалами',
    'terminals.addTerminal': 'Добавить терминал',
    'terminals.editTerminal': 'Редактировать терминал',
    'terminals.deleteTerminal': 'Удалить терминал',
    'terminals.confirmDelete': 'Вы уверены, что хотите удалить терминал?',
    'terminals.apiKeys': 'API ключи',
    'terminals.terminalId': 'Terminal ID',
    'terminals.apiKey': 'API Key',
    'terminals.secretKey': 'Secret Key',
    'terminals.regenerateKeys': 'Перегенерировать ключи',
    'terminals.confirmRegenerate': 'Все текущие интеграции перестанут работать!',
    'terminals.keysWarning': 'Никогда не делитесь секретным ключом! Используйте его только на сервере.',
    'terminals.currency': 'Валюта',
    'terminals.merchant': 'Мерчант',
    'terminals.provider': 'Провайдер',
    'terminals.priority': 'Приоритет',
    'terminals.commission': 'Комиссия',
    'terminals.name': 'Название',
    'terminals.search': 'Поиск по названию терминала...',
    'terminals.allProviders': 'Все провайдеры',
    'terminals.find': 'Найти',

    // Commissions
    'commissions.title': 'Комиссии',
    'commissions.subtitle': 'Управление комиссиями',
    'commissions.addCommission': 'Добавить комиссию',
    'commissions.editCommission': 'Редактировать комиссию',
    'commissions.deleteCommission': 'Удалить комиссию',
    'commissions.confirmDelete': 'Вы уверены, что хотите удалить комиссию?',
    'commissions.percent': 'Процент',
    'commissions.fixed': 'Фиксированная',
    'commissions.minAmount': 'Мин. сумма',
    'commissions.maxAmount': 'Макс. сумма',

    // Providers
    'providers.title': 'Провайдеры',
    'providers.subtitle': 'Платёжные провайдеры',
    'providers.addProvider': 'Добавить провайдера',
    'providers.editProvider': 'Редактировать провайдера',
    'providers.deleteProvider': 'Удалить провайдера',
    'providers.confirmDelete': 'Вы уверены, что хотите удалить провайдера?',
    'providers.code': 'Код',
    'providers.priority': 'Приоритет',

    // Reports
    'reports.title': 'Отчёты',
    'reports.subtitle': 'Финансовые отчёты',
    'reports.period': 'Период',
    'reports.generate': 'Сформировать',
    'reports.download': 'Скачать',
    'reports.turnover': 'Оборот',
    'reports.byMerchant': 'По мерчантам',
    'reports.byGateway': 'По шлюзам',
    'reports.daily': 'По дням',

    // Analytics
    'analytics.title': 'Аналитика',
    'analytics.subtitle': 'Детальная статистика платежей',
    'analytics.period': 'Период',
    'analytics.days7': '7 дней',
    'analytics.days30': '30 дней',
    'analytics.days90': '90 дней',
    'analytics.months6': '6 месяцев',
    'analytics.year': 'Год',
    'analytics.trend': 'Динамика платежей',
    'analytics.distribution': 'Распределение по статусу',
    'analytics.comparison': 'Успешные vs Отклонённые',
    'analytics.gateways': 'Производительность шлюзов',
    'analytics.totalPayments': 'Всего платежей',
    'analytics.totalAmount': 'Общая сумма',
    'analytics.approvalRate': 'Уровень одобрения',
    'analytics.avgAmount': 'Средний платёж',

    // AML
    'aml.title': 'AML / Антифрод',
    'aml.subtitle': 'Мониторинг и правила безопасности',
    'aml.alerts': 'Алерты',
    'aml.rules': 'Правила',
    'aml.addRule': 'Новое правило',
    'aml.editRule': 'Редактировать правило',
    'aml.deleteRule': 'Удалить правило?',
    'aml.confirmDelete': 'Вы уверены, что хотите удалить правило?',
    'aml.ruleType': 'Тип правила',
    'aml.action': 'Действие',
    'aml.parameters': 'Параметры',
    'aml.approve': 'Одобрить',
    'aml.block': 'Заблокировать',
    'aml.review': 'На проверку',
    'aml.riskLow': 'Низкий',
    'aml.riskMedium': 'Средний',
    'aml.riskHigh': 'Высокий',
    'aml.riskCritical': 'Критический',
    'aml.statusPending': 'На проверке',
    'aml.statusApproved': 'Одобрен',
    'aml.statusBlocked': 'Заблокирован',
    'aml.totalAlerts': 'Всего алертов',
    'aml.pendingCount': 'На проверке',
    'aml.blockedCount': 'Заблокировано',
    'aml.approvedCount': 'Одобрено',
    'aml.highRiskCount': 'Высокий риск',
    'aml.alertsToday': 'Сегодня',
    'aml.amountLimit': 'Лимит суммы',
    'aml.velocity': 'Частота транзакций',
    'aml.countryBlock': 'Блокировка страны',
    'aml.cardBlock': 'Блокировка карты',
    'aml.ipBlock': 'Блокировка IP',
    'aml.threshold': 'Порог',
    'aml.timeWindow': 'Окно времени (минуты)',
    'aml.maxTransactions': 'Макс. транзакций',
    'aml.countryCodes': 'Коды стран',
    'aml.cardMasks': 'Маски карт',
    'aml.ipAddresses': 'IP адреса',
    'aml.toggleActive': 'Вкл/Выкл',

    // Audit
    'audit.title': 'Аудит',
    'audit.subtitle': 'Журнал действий',
    'audit.user': 'Пользователь',
    'audit.action': 'Действие',
    'audit.entity': 'Объект',
    'audit.ip': 'IP адрес',
    'audit.timestamp': 'Время',
    'audit.changes': 'Изменения',

    // Webhooks
    'webhooks.title': 'Webhooks',
    'webhooks.subtitle': 'Настройка HTTP уведомлений',
    'webhooks.addWebhook': 'Добавить webhook',
    'webhooks.editWebhook': 'Редактировать webhook',
    'webhooks.deleteWebhook': 'Удалить webhook',
    'webhooks.confirmDelete': 'Вы уверены?',
    'webhooks.url': 'URL',
    'webhooks.secret': 'Секретный ключ',
    'webhooks.events': 'События',
    'webhooks.test': 'Тест',
    'webhooks.logs': 'История',
    'webhooks.info': 'Webhooks позволяют получать уведомления о событиях в реальном времени на ваш сервер.',

    // Notifications
    'notifications.title': 'Уведомления',
    'notifications.subtitle': 'Настройки уведомлений',
    'notifications.settings': 'Настройки уведомлений',
    'notifications.markAllRead': 'Отметить все как прочитанные',
    'notifications.noNotifications': 'Нет уведомлений',
    'notifications.telegram': 'Telegram',
    'notifications.email': 'Email',
    'notifications.telegramChatId': 'Telegram Chat ID',
    'notifications.emailAddress': 'Email адрес',
    'notifications.testNotification': 'Тестовое уведомление',
    'notifications.sendTest': 'Отправить тест',
    'notifications.alertTypes': 'Типы алертов',

    // Roles
    'role.super_admin': 'Супер Админ',
    'role.admin': 'Админ',
    'role.accountant': 'Бухгалтерия',
    'role.analyst': 'Аналитик',
    'role.aml_officer': 'AML',
    'role.lawyer': 'Юрист',
    'role.manager': 'Менеджер',
    'role.user': 'Пользователь',

    // Events
    'event.payment.success': 'Успешный платёж',
    'event.payment.failed': 'Отклонённый платёж',
    'event.payment.refunded': 'Возврат платежа',
    'event.merchant.created': 'Создан мерчант',
    'event.merchant.updated': 'Обновлён мерчант',
    'event.merchant.deleted': 'Удалён мерчант',
    'event.aml.alert': 'AML алерт',
    'event.aml.blocked': 'AML блокировка',
    'event.user.created': 'Создан пользователь',
    'event.user.updated': 'Обновлён пользователь',
  },

  en: {
    // Navigation
    'nav.dashboard': 'Dashboard',
    'nav.payments': 'Payments',
    'nav.merchants': 'Merchants',
    'nav.providers': 'Providers',
    'nav.terminals': 'Terminals',
    'nav.commissions': 'Commissions',
    'nav.reports': 'Reports',
    'nav.analytics': 'Analytics',
    'nav.aml': 'AML',
    'nav.audit': 'Audit',
    'nav.users': 'Users',
    'nav.notifications': 'Notifications',
    'nav.webhooks': 'Webhooks',
    'nav.settings': 'Settings',
    'nav.logout': 'Log out',

    // Common
    'common.search': 'Search',
    'common.filter': 'Filter',
    'common.add': 'Add',
    'common.edit': 'Edit',
    'common.delete': 'Delete',
    'common.save': 'Save',
    'common.cancel': 'Cancel',
    'common.confirm': 'Confirm',
    'common.loading': 'Loading...',
    'common.noData': 'No data',
    'common.refresh': 'Refresh',
    'common.export': 'Export',
    'common.all': 'All',
    'common.active': 'Active',
    'common.inactive': 'Inactive',
    'common.status': 'Status',
    'common.actions': 'Actions',
    'common.name': 'Name',
    'common.email': 'Email',
    'common.password': 'Password',
    'common.role': 'Role',
    'common.created': 'Created',
    'common.updated': 'Updated',
    'common.total': 'Total',
    'common.success': 'Success',
    'common.error': 'Error',
    'common.yes': 'Yes',
    'common.no': 'No',
    'common.copy': 'Copy',
    'common.copied': 'Copied',
    'common.date': 'Date',
    'common.type': 'Type',
    'common.description': 'Description',
    'common.details': 'Details',
    'common.close': 'Close',
    'common.create': 'Create',
    'common.update': 'Update',
    'common.view': 'View',

    // Auth
    'auth.login': 'Log in',
    'auth.logout': 'Log out',
    'auth.email': 'Email',
    'auth.password': 'Password',
    'auth.loginTitle': 'Sign in',
    'auth.loginSubtitle': 'Enter your credentials',
    'auth.loginError': 'Invalid email or password',
    'auth.welcome': 'Welcome',

    // Dashboard
    'dashboard.title': 'Dashboard',
    'dashboard.totalPayments': 'Total payments',
    'dashboard.totalAmount': 'Total amount',
    'dashboard.conversion': 'Conversion',
    'dashboard.avgCheck': 'Average check',
    'dashboard.successful': 'Successful',
    'dashboard.failed': 'Failed',
    'dashboard.pending': 'Pending',
    'dashboard.todayPayments': 'Payments today',
    'dashboard.todayAmount': 'Amount today',
    'dashboard.merchants': 'Merchants',
    'dashboard.terminals': 'Terminals',

    // Users
    'users.title': 'Users',
    'users.subtitle': 'Manage system employees',
    'users.addUser': 'Add user',
    'users.editUser': 'Edit user',
    'users.deleteUser': 'Delete user',
    'users.searchPlaceholder': 'Search by name or email...',
    'users.allRoles': 'All roles',
    'users.allStatuses': 'All statuses',
    'users.blocked': 'Blocked',
    'users.admins': 'Admins',
    'users.telegram': 'Telegram ID',
    'users.confirmDelete': 'Are you sure you want to delete this user?',
    'users.block': 'Block',
    'users.unblock': 'Unblock',
    'users.totalUsers': 'Total users',
    'users.activeUsers': 'Active',
    'users.blockedUsers': 'Blocked',
    'users.role': 'Role',
    'users.name': 'Name',
    'users.lastLogin': 'Last login',
    'users.status': 'Status',

    // Payments
    'payments.title': 'Payments',
    'payments.subtitle': 'Transaction history',
    'payments.search': 'Search payments',
    'payments.refund': 'Refund',
    'payments.amount': 'Amount',
    'payments.merchant': 'Merchant',
    'payments.gateway': 'Gateway',
    'payments.approved': 'Approved',
    'payments.declined': 'Declined',
    'payments.processing': 'Processing',
    'payments.refunded': 'Refunded',
    'payments.id': 'Payment ID',
    'payments.card': 'Card',
    'payments.confirmRefund': 'Confirm refund?',

    // Merchants
    'merchants.title': 'Merchants',
    'merchants.subtitle': 'Manage merchants',
    'merchants.search': 'Search merchants...',
    'merchants.addMerchant': 'Add merchant',
    'merchants.editMerchant': 'Edit merchant',
    'merchants.deleteMerchant': 'Delete merchant',
    'merchants.confirmDelete': 'Are you sure you want to delete the merchant?',
    'merchants.company': 'Company',
    'merchants.bin': 'BIN',
    'merchants.phone': 'Phone',
    'merchants.address': 'Address',
    'merchants.balance': 'Balance',

    // Terminals
    'terminals.title': 'Terminals',
    'terminals.subtitle': 'Manage terminals',
    'terminals.addTerminal': 'Add terminal',
    'terminals.editTerminal': 'Edit terminal',
    'terminals.deleteTerminal': 'Delete terminal',
    'terminals.confirmDelete': 'Are you sure you want to delete the terminal?',
    'terminals.apiKeys': 'API Keys',
    'terminals.terminalId': 'Terminal ID',
    'terminals.apiKey': 'API Key',
    'terminals.secretKey': 'Secret Key',
    'terminals.regenerateKeys': 'Regenerate keys',
    'terminals.confirmRegenerate': 'All current integrations will stop working!',
    'terminals.keysWarning': 'Never share the secret key! Use it only on your server.',
    'terminals.currency': 'Currency',
    'terminals.merchant': 'Merchant',
    'terminals.provider': 'Provider',
    'terminals.priority': 'Priority',
    'terminals.commission': 'Commission',
    'terminals.name': 'Name',
    'terminals.search': 'Search by terminal name...',
    'terminals.allProviders': 'All providers',
    'terminals.find': 'Find',

    // Commissions
    'commissions.title': 'Commissions',
    'commissions.subtitle': 'Manage commissions',
    'commissions.addCommission': 'Add commission',
    'commissions.editCommission': 'Edit commission',
    'commissions.deleteCommission': 'Delete commission',
    'commissions.confirmDelete': 'Are you sure you want to delete the commission?',
    'commissions.percent': 'Percent',
    'commissions.fixed': 'Fixed',
    'commissions.minAmount': 'Min amount',
    'commissions.maxAmount': 'Max amount',

    // Providers
    'providers.title': 'Providers',
    'providers.subtitle': 'Payment providers',
    'providers.addProvider': 'Add provider',
    'providers.editProvider': 'Edit provider',
    'providers.deleteProvider': 'Delete provider',
    'providers.confirmDelete': 'Are you sure you want to delete the provider?',
    'providers.code': 'Code',
    'providers.priority': 'Priority',

    // Reports
    'reports.title': 'Reports',
    'reports.subtitle': 'Financial reports',
    'reports.period': 'Period',
    'reports.generate': 'Generate',
    'reports.download': 'Download',
    'reports.turnover': 'Turnover',
    'reports.byMerchant': 'By merchants',
    'reports.byGateway': 'By gateways',
    'reports.daily': 'Daily',

    // Analytics
    'analytics.title': 'Analytics',
    'analytics.subtitle': 'Detailed payment statistics',
    'analytics.period': 'Period',
    'analytics.days7': '7 days',
    'analytics.days30': '30 days',
    'analytics.days90': '90 days',
    'analytics.months6': '6 months',
    'analytics.year': 'Year',
    'analytics.trend': 'Payment trend',
    'analytics.distribution': 'Status distribution',
    'analytics.comparison': 'Successful vs Failed',
    'analytics.gateways': 'Gateway performance',
    'analytics.totalPayments': 'Total payments',
    'analytics.totalAmount': 'Total amount',
    'analytics.approvalRate': 'Approval rate',
    'analytics.avgAmount': 'Average payment',

    // AML
    'aml.title': 'AML / Antifraud',
    'aml.subtitle': 'Security monitoring and rules',
    'aml.alerts': 'Alerts',
    'aml.rules': 'Rules',
    'aml.addRule': 'New rule',
    'aml.editRule': 'Edit rule',
    'aml.deleteRule': 'Delete rule?',
    'aml.confirmDelete': 'Are you sure you want to delete the rule?',
    'aml.ruleType': 'Rule type',
    'aml.action': 'Action',
    'aml.parameters': 'Parameters',
    'aml.approve': 'Approve',
    'aml.block': 'Block',
    'aml.review': 'Review',
    'aml.riskLow': 'Low',
    'aml.riskMedium': 'Medium',
    'aml.riskHigh': 'High',
    'aml.riskCritical': 'Critical',
    'aml.statusPending': 'Pending',
    'aml.statusApproved': 'Approved',
    'aml.statusBlocked': 'Blocked',
    'aml.totalAlerts': 'Total alerts',
    'aml.pendingCount': 'Pending',
    'aml.blockedCount': 'Blocked',
    'aml.approvedCount': 'Approved',
    'aml.highRiskCount': 'High risk',
    'aml.alertsToday': 'Today',
    'aml.amountLimit': 'Amount limit',
    'aml.velocity': 'Transaction velocity',
    'aml.countryBlock': 'Country block',
    'aml.cardBlock': 'Card block',
    'aml.ipBlock': 'IP block',
    'aml.threshold': 'Threshold',
    'aml.timeWindow': 'Time window (minutes)',
    'aml.maxTransactions': 'Max transactions',
    'aml.countryCodes': 'Country codes',
    'aml.cardMasks': 'Card masks',
    'aml.ipAddresses': 'IP addresses',
    'aml.toggleActive': 'Toggle',

    // Audit
    'audit.title': 'Audit',
    'audit.subtitle': 'Action log',
    'audit.user': 'User',
    'audit.action': 'Action',
    'audit.entity': 'Entity',
    'audit.ip': 'IP address',
    'audit.timestamp': 'Time',
    'audit.changes': 'Changes',

    // Webhooks
    'webhooks.title': 'Webhooks',
    'webhooks.subtitle': 'HTTP notification settings',
    'webhooks.addWebhook': 'Add webhook',
    'webhooks.editWebhook': 'Edit webhook',
    'webhooks.deleteWebhook': 'Delete webhook',
    'webhooks.confirmDelete': 'Are you sure?',
    'webhooks.url': 'URL',
    'webhooks.secret': 'Secret key',
    'webhooks.events': 'Events',
    'webhooks.test': 'Test',
    'webhooks.logs': 'History',
    'webhooks.info': 'Webhooks allow you to receive real-time event notifications to your server.',

    // Notifications
    'notifications.title': 'Notifications',
    'notifications.subtitle': 'Notification settings',
    'notifications.settings': 'Notification settings',
    'notifications.markAllRead': 'Mark all as read',
    'notifications.noNotifications': 'No notifications',
    'notifications.telegram': 'Telegram',
    'notifications.email': 'Email',
    'notifications.telegramChatId': 'Telegram Chat ID',
    'notifications.emailAddress': 'Email address',
    'notifications.testNotification': 'Test notification',
    'notifications.sendTest': 'Send test',
    'notifications.alertTypes': 'Alert types',

    // Roles
    'role.super_admin': 'Super Admin',
    'role.admin': 'Admin',
    'role.accountant': 'Accountant',
    'role.analyst': 'Analyst',
    'role.aml_officer': 'AML Officer',
    'role.lawyer': 'Lawyer',
    'role.manager': 'Manager',
    'role.user': 'User',

    // Events
    'event.payment.success': 'Successful payment',
    'event.payment.failed': 'Failed payment',
    'event.payment.refunded': 'Refunded payment',
    'event.merchant.created': 'Merchant created',
    'event.merchant.updated': 'Merchant updated',
    'event.merchant.deleted': 'Merchant deleted',
    'event.aml.alert': 'AML alert',
    'event.aml.blocked': 'AML blocked',
    'event.user.created': 'User created',
    'event.user.updated': 'User updated',
  },

  kz: {
    // Navigation
    'nav.dashboard': 'Басты бет',
    'nav.payments': 'Төлемдер',
    'nav.merchants': 'Мерчанттар',
    'nav.providers': 'Провайдерлер',
    'nav.terminals': 'Терминалдар',
    'nav.commissions': 'Комиссиялар',
    'nav.reports': 'Есептер',
    'nav.analytics': 'Аналитика',
    'nav.aml': 'AML',
    'nav.audit': 'Аудит',
    'nav.users': 'Пайдаланушылар',
    'nav.notifications': 'Хабарламалар',
    'nav.webhooks': 'Webhooks',
    'nav.settings': 'Баптаулар',
    'nav.logout': 'Шығу',

    // Common
    'common.search': 'Іздеу',
    'common.filter': 'Сүзгі',
    'common.add': 'Қосу',
    'common.edit': 'Өзгерту',
    'common.delete': 'Жою',
    'common.save': 'Сақтау',
    'common.cancel': 'Болдырмау',
    'common.confirm': 'Растау',
    'common.loading': 'Жүктелуде...',
    'common.noData': 'Деректер жоқ',
    'common.refresh': 'Жаңарту',
    'common.export': 'Экспорт',
    'common.all': 'Барлығы',
    'common.active': 'Белсенді',
    'common.inactive': 'Белсенді емес',
    'common.status': 'Күй',
    'common.actions': 'Әрекеттер',
    'common.name': 'Атауы',
    'common.email': 'Email',
    'common.password': 'Құпия сөз',
    'common.role': 'Рөл',
    'common.created': 'Жасалды',
    'common.updated': 'Жаңартылды',
    'common.total': 'Барлығы',
    'common.success': 'Сәтті',
    'common.error': 'Қате',
    'common.yes': 'Иә',
    'common.no': 'Жоқ',
    'common.copy': 'Көшіру',
    'common.copied': 'Көшірілді',
    'common.date': 'Күні',
    'common.type': 'Түрі',
    'common.description': 'Сипаттама',
    'common.details': 'Толық ақпарат',
    'common.close': 'Жабу',
    'common.create': 'Жасау',
    'common.update': 'Жаңарту',
    'common.view': 'Көру',

    // Auth
    'auth.login': 'Кіру',
    'auth.logout': 'Шығу',
    'auth.email': 'Email',
    'auth.password': 'Құпия сөз',
    'auth.loginTitle': 'Жүйеге кіру',
    'auth.loginSubtitle': 'Кіру үшін деректерді енгізіңіз',
    'auth.loginError': 'Email немесе құпия сөз қате',
    'auth.welcome': 'Қош келдіңіз',

    // Dashboard
    'dashboard.title': 'Басты бет',
    'dashboard.totalPayments': 'Барлық төлемдер',
    'dashboard.totalAmount': 'Жалпы сомасы',
    'dashboard.conversion': 'Конверсия',
    'dashboard.avgCheck': 'Орташа чек',
    'dashboard.successful': 'Сәтті',
    'dashboard.failed': 'Қабылданбады',
    'dashboard.pending': 'Өңделуде',
    'dashboard.todayPayments': 'Бүгінгі төлемдер',
    'dashboard.todayAmount': 'Бүгінгі сома',
    'dashboard.merchants': 'Мерчанттар',
    'dashboard.terminals': 'Терминалдар',

    // Users
    'users.title': 'Пайдаланушылар',
    'users.subtitle': 'Жүйе қызметкерлерін басқару',
    'users.addUser': 'Пайдаланушы қосу',
    'users.editUser': 'Пайдаланушыны өзгерту',
    'users.deleteUser': 'Пайдаланушыны жою',
    'users.searchPlaceholder': 'Аты немесе email бойынша іздеу...',
    'users.allRoles': 'Барлық рөлдер',
    'users.allStatuses': 'Барлық күйлер',
    'users.blocked': 'Бұғатталған',
    'users.admins': 'Әкімшілер',
    'users.telegram': 'Telegram ID',
    'users.confirmDelete': 'Сіз бұл пайдаланушыны жойғыңыз келе ме?',
    'users.block': 'Бұғаттау',
    'users.unblock': 'Бұғаттан шығару',
    'users.totalUsers': 'Барлық пайдаланушылар',
    'users.activeUsers': 'Белсенді',
    'users.blockedUsers': 'Бұғатталған',

    // Terminals
    'terminals.title': 'Терминалдар',
    'terminals.subtitle': 'Терминалдарды басқару',
    'terminals.addTerminal': 'Терминал қосу',
    'terminals.editTerminal': 'Терминалды өзгерту',
    'terminals.deleteTerminal': 'Терминалды жою',
    'terminals.confirmDelete': 'Терминалды жойғыңыз келе ме?',
    'terminals.apiKeys': 'API кілттері',
    'terminals.terminalId': 'Terminal ID',
    'terminals.apiKey': 'API Key',
    'terminals.secretKey': 'Secret Key',
    'terminals.regenerateKeys': 'Кілттерді қайта жасау',
    'terminals.confirmRegenerate': 'Барлық интеграциялар жұмысын тоқтатады!',
    'terminals.keysWarning': 'Құпия кілтті ешқашан бөліспеңіз!',
    'terminals.currency': 'Валюта',
    'terminals.merchant': 'Мерчант',
    'terminals.provider': 'Провайдер',
    'terminals.priority': 'Приоритет',
    'terminals.commission': 'Комиссия',
    'terminals.name': 'Название',
    'terminals.search': 'Поиск по названию терминала...',
    'terminals.allProviders': 'Все провайдеры',
    'terminals.find': 'Найти',

    // AML
    'aml.title': 'AML / Антифрод',
    'aml.subtitle': 'Қауіпсіздік мониторингі және ережелері',
    'aml.alerts': 'Ескертулер',
    'aml.rules': 'Ережелер',
    'aml.addRule': 'Жаңа ереже',
    'aml.editRule': 'Ережені өзгерту',
    'aml.deleteRule': 'Ережені жою?',
    'aml.approve': 'Мақұлдау',
    'aml.block': 'Бұғаттау',
    'aml.review': 'Тексеру',
    'aml.riskLow': 'Төмен',
    'aml.riskMedium': 'Орташа',
    'aml.riskHigh': 'Жоғары',
    'aml.riskCritical': 'Сыни',

    // Roles
    'role.super_admin': 'Супер Әкімші',
    'role.admin': 'Әкімші',
    'role.accountant': 'Бухгалтер',
    'role.analyst': 'Аналитик',
    'role.aml_officer': 'AML',
    'role.lawyer': 'Заңгер',
    'role.manager': 'Менеджер',
    'role.user': 'Пайдаланушы',
  },
};

// Context
const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('language');
    return saved && LANGUAGES[saved] ? saved : 'ru';
  });

  useEffect(() => {
    localStorage.setItem('language', language);
    document.documentElement.lang = language;
  }, [language]);

  const t = (key, params = {}) => {
    let text = translations[language]?.[key] || translations['ru']?.[key] || key;
    
    // Replace parameters
    Object.entries(params).forEach(([k, v]) => {
      text = text.replace(`{${k}}`, v);
    });
    
    return text;
  };

  const value = {
    language,
    setLanguage,
    t,
    languages: LANGUAGES,
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;
